import { createReducer, on } from '@ngrx/store';

import { CustomFieldDefinitions } from 'ish-core/models/custom-field-definition/custom-field-definition.model';
import { ServerConfig } from 'ish-core/models/server-config/server-config.model';

import {
  loadCustomFieldTranslationsSuccess,
  loadExtraConfigSuccess,
  loadServerConfigSuccess,
} from './server-config.actions';

// _config is not updated in SSR ngrx state.
// As ngrx-state-transfer filters state without '_' prefix, changed _config to config.
export interface ServerConfigState {
  config: ServerConfig;
  definitions: CustomFieldDefinitions;
  extra: ServerConfig;
}

const initialState: ServerConfigState = {
  config: undefined,
  definitions: undefined,
  extra: undefined,
};

export const serverConfigReducer = createReducer(
  initialState,
  on(loadServerConfigSuccess, (state, action): ServerConfigState => ({
    ...state,
    config: action.payload.config,
    definitions: action.payload.definitions,
  })),
  on(loadCustomFieldTranslationsSuccess, (state, action): ServerConfigState => ({
    ...state,
    definitions: { ...state.definitions, entities: action.payload.definitionEntities },
  })),
  on(loadExtraConfigSuccess, (state, action): ServerConfigState => ({
    ...state,
    extra: action.payload.extra,
  }))
);
